<form [formGroup]="editProfileUsernameForm" (ngSubmit)="onSubmitEditProfileNameForm()" class="wrapper-edit-info-page">
  <span class="title-edit-page">{{'NEW_TEXT.username' | translate}}</span>
  <span class="subtitle-edit-page">{{'NEW_TEXT.change_your_account_username_changing_username_can_be_performed_once_every_90_days_the_update_will_take_effect_immediately' | translate}}</span>
  <div class="wrapper-input" [ngClass]="{'error': editProfileUsernameForm.controls['username'] | formControlErrorMessages: null : formTriedToSubmit}">
    <span class="label-input">{{'NEW_TEXT.username' | translate}}</span>
    <div class="custom-input">
      <input type="text" [maxLength]="50" formControlName="username">
    </div>
    <div *ngIf="editProfileUsernameForm.controls['username'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
      <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
      <span>{{editProfileUsernameForm.controls['username'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
    </div>
    <span class="label-info-input" *ngIf="!(editProfileUsernameForm.controls['username'] | formControlErrorMessages: null: formTriedToSubmit)">{{editProfileUsernameForm.controls['username'].value ? (50 - editProfileUsernameForm.controls['username'].value.length) + ' characters left.' : 'The maximum length of a username is 50 characters.'}}</span>
  </div>
  <div class="buttons-edit-page">
    <button type="button" (click)="onCancelChanges()" class="custom-btn custom-btn--outline">
      <span>{{'NEW_TEXT.cancel' | translate}}</span>
    </button>
    <button type="submit" class="custom-btn custom-btn--primary">
      <span *ngIf="!isSpinnerActive">{{'NEW_TEXT.save_changes' | translate}}</span>
      <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
    </button>
  </div>
</form>
